<template>
    <div class="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
      <div class="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
        <h2 class="text-xl font-bold mb-4 text-gray-800">Category Details</h2>
        <p><strong>Category Name:</strong> {{ category.name}}</p>
        <p><strong>Description:</strong> {{ category.description }}</p>
        <p><strong>Created At:</strong> {{ formatDate(category.createdAt) }}</p>

        <button @click="closeModal" class="mt-4 w-full text-gray-600">Close</button>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
        category: {
        },
    },
    data() {
      return {
      };
    },
    methods: {
      closeModal() {
        this.$emit('closeModal');
      },
      formatDate(date) {
        return new Date(date).toLocaleDateString();
      },
    },
  };
  </script>
  